import { css, styled } from 'styled-components'

import { EmptyState, Button } from '@b-stock/fe-core/bstock-react'
import { Breakpoints, Colors, Typography } from '@b-stock/fe-core/design-system'

export const ModalEmptyState = styled(EmptyState)`
  && {
    > div:nth-child(2) {
      ${Typography.Title3}
    }
  }
`

export const SearchList = styled.ul`
  --gap: 1.5rem;

  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: var(--gap);

  @media ${Breakpoints.min.large} {
    width: 100vw;
    max-width: 60.5rem;
  }
`

type SavedSearchLi = {
  $height: string
  $shouldCollapse: boolean
}

export const SavedSearchLi = styled.li<SavedSearchLi>`
  overflow: hidden;
  box-shadow: inset 0 0 0 0.0625rem ${Colors.Semantic.Neutral.medium_grey};
  border-radius: 0.5rem;

  &:has(input:checked) {
    box-shadow: inset 0 0 0 0.0625rem
      ${Colors.Semantic.BStock.default.lightBackground};
  }

  ${({ $height, $shouldCollapse }) => css`
    transition: box-shadow 0.1s ease-in-out
      ${
        $shouldCollapse &&
        `, height 0.5s ease-in-out,
      margin-bottom 0.25s ease-in-out 0.25s`
      };
    height: ${$shouldCollapse ? 0 : $height};
    margin-bottom: ${$shouldCollapse ? 'calc(var(--gap) * -1)' : 0};
  `}
`

export const SavedSearchLabel = styled.label`
  display: flex;
  gap: 1.5rem;
  padding: 1rem 1.5rem;
  cursor: pointer;

  // an input it used for free keyboard accessibility, so hide it
  input[type='checkbox'] {
    position: absolute;
    opacity: 0;
    left: -9999px;
  }

  > button {
    width: 1.5rem;

    svg {
      font-size: 1.5rem;
    }
  }

  @media ${Breakpoints.min.medium} {
    gap: 3rem;
  }
`

export const SavedSearchItemContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  flex-grow: 1;
`

export const SavedSearchItemName = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;

  p {
    ${Typography.Subtitle1}
    color: ${Colors.Semantic.Neutral.black}
  }

  input {
    flex-grow: 1;
  }
`

export const EditButton = styled(Button).attrs({
  appearance: 'plainTertiary',
  type: 'button',
})`
  padding: 0.25rem;
`

export const CancelButton = styled(Button).attrs({
  appearance: 'plainTertiary',
  type: 'button',
})`
  color: ${Colors.Semantic.Error.highlight};
  font-size: 1rem;
`

export const SaveButton = styled(Button).attrs({
  appearance: 'plainTertiary',
  type: 'submit',
})`
  color: ${Colors.Semantic.Success.copy};
  font-size: 1rem;
`

export const SavedSearchItemChips = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  gap: 0.75rem;
  flex-wrap: wrap;
`

export const SavedSearchItemChip = styled.li`
  ${Typography.Body4};
  color: ${Colors.Semantic.Neutral.black};
  padding: 0.375rem 1rem;
  border-radius: 6.25rem;
  border: 0.0625rem solid ${Colors.Semantic.Neutral.medium_grey};
`
